import { getApiUrl } from '../../utils/shared/helpers';
import { checkStatus, handleError } from '../../utils/api';
import { mapEligibilityCheck } from '../register/helpers';
import { EligibilityCheckResponse } from '../../interfaces/register';
import { setCoverageProviderTypes } from '../../lib/coverageCheckStore';

interface EligibilityCheck {
  eligibilityCheck: EligibilityCheckResponse | undefined;
}

// Unauthenticated guest 270 poll for the coverage-check pre-registration flow. The token is
// Stern's unguessable SecureRandom.uuid; no JWT, so fetch directly. Same { eligibilityCheck }
// return shape (mapEligibilityCheck applied) as getEligibilityCheckAsync.
const getGuestEligibilityCheckAsync = async (
  id: string
): Promise<EligibilityCheck> => {
  const url = `${getApiUrl()}/api/v1/preauth_eligibility_check/${id}`;

  try {
    const response = await fetch(url, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    });

    await checkStatus(response);

    const {
      eligibility_check: eligibilityCheck,
      provider_types: providerTypes,
    } = await response.json();

    // On an eligible 270, Stern returns the affiliation's priced provider types; carry them into
    // the coverage store so the benefits screen can render tiles (no CSV roster match needed).
    if (Array.isArray(providerTypes) && providerTypes.length) {
      setCoverageProviderTypes(providerTypes);
    }

    return { eligibilityCheck: mapEligibilityCheck(eligibilityCheck) };
  } catch (error) {
    handleError('unexpected status - get guest eligibility check', error);
    return { eligibilityCheck: undefined };
  }
};

export default getGuestEligibilityCheckAsync;
